import { Stream } from 'stream';
import {SET_INFO_DATA,SET_SLOW_NETWORK,SET_HOST_SECONDS,SET_ALL_ATTENDEE_LIST,SET_USER_REPSITE_DATA,SET_USER_CONFIGURATION_DATA,SET_CREATE_STREAM_DATA,SET_TOKEN_DATA,SET_JOIN_DATA,SET_JOIN_ATTENDEEID_DATA,SET_ATTENDEE_TOKEN,SET_RTM_TOKEN,SET_HOST_TIME,SET_PERSON_NUM,SET_ATTENDEE_LIST, SET_STREAM_STATE, SET_PRESENTER_NUM,SET_STREAM_WIDTH,SET_STREAM_HEIGHT,SET_HOST_CONNECTION_STATUS} from './livemain.actionTypes'


const initialState = {
    repsiteData: {},
    configurationData:{
        "authentication": {
            "stream_password": ""
        },
        "description": "",
        "display_language": null,
        "interaction_library": [],
        "limits": {
            "maximum_attendees": 0,
            "maximum_presenters": 0,
            "maximum_streams_per_day": 0,
            "maximum_time_per_stream": 0
        },
        "locale": null,
        "options": {
            "attendee": {
                "enable_2fa": false,
                "enable_camera": false,
                "enable_chat": false,
                "enable_microphone": false,
                "enable_multiple_hosts": false,
                "enable_password": false,
                "enable_private_messages": false
            },
            "host": {
                "enable_camera": false,
                "enable_microphone": false
            }
        },
        "region": "america",
        "stream_id": 1000001000,
        "stream_secret": "",
        "stream_slug": "",
        "title": "",
        "host_id": "112659367526568132455",
        "host_fullname": "",
        "host_picture": null,
        "company_name": null
    },
    createStreamData:{},
    tokenData:{},
    joinData:{},
    joinWithAttendeeData:{},
    attendeeTokenData:{},
    rtmTokenData:{},
    hostTime: 0,
    personNum: 0,
    attendeeList: [],
    allAttendeeList: [],
    streamState: "notStarted",
    presenterNum: 0,
    StreamWidth: 960,
    streamHeight: 720,
    hostSeconds:0,
    slowNetwork: false,
    isHostConnected: true,
    infoData: {
        "streamInstanceId": "04475666-7808-4e22-a217-c26b42fc63c7",
        "hostModel": {
            "clientId": "repsites",
            "userId": "marketamer-943788",
            "sub": ""
        }
    },

}

export default function livemain(state = initialState, action: any) {
    
    switch (action.type) {
        case SET_INFO_DATA:{
            return {
                ...state,
                infoData:action.payload
            };
        }
        case SET_USER_REPSITE_DATA:{
            return {
                ...state,
                repsiteData:action.payload
            };
        }
        case SET_USER_CONFIGURATION_DATA:{
            return {
                ...state,
                configurationData:action.payload
            };
        }
        case SET_CREATE_STREAM_DATA:{
            return {
                ...state,
                createStreamData:action.payload
            };
        }
        case SET_TOKEN_DATA:{
            return {
                ...state,
                tokenData:action.payload
            };
        }
        case SET_JOIN_DATA:{
            return {
                ...state,
                joinData:action.payload
            };
        }
        case SET_JOIN_ATTENDEEID_DATA:{
            return {
                ...state,
                joinWithAttendeeData:action.payload
            };
        }
        case SET_ATTENDEE_TOKEN:{
            return {
                ...state,
                attendeeTokenData:action.payload
            };
        }
        case SET_RTM_TOKEN:{
            return {
                ...state,
                rtmTokenData:action.payload
            };
        }
        case SET_HOST_TIME: {
            return {
                ...state,
                hostTime:action.payload
            };
        }
        case SET_PERSON_NUM: {
            return {
                ...state,
                personNum:action.payload
            };
        }
        case SET_ATTENDEE_LIST: {
            return {
                ...state,
                attendeeList:action.payload
            };
        }
        case SET_ALL_ATTENDEE_LIST: {
            return {
                ...state,
                allAttendeeList:action.payload
            };
        }
        case SET_STREAM_STATE:{
            return {
                ...state,
                streamState:action.payload
            };
        }
        case SET_PRESENTER_NUM:{
            return {
                ...state,
                presenterNum:action.payload
            };
        }
        case SET_STREAM_WIDTH:{
            return {
                ...state,
                streamWidth:action.payload
            };
        }
        case SET_STREAM_HEIGHT:{
            return {
                ...state,
                streamHeight:action.payload
            };
        }
        case SET_HOST_SECONDS:{
            return {
                ...state,
                hostSeconds:action.payload
            };
        }
        case SET_SLOW_NETWORK:{
            return {
                ...state,
                slowNetwork:action.payload
            };
        }
        case SET_HOST_CONNECTION_STATUS:{
            return {
                ...state,
                isHostConnected:action.payload
            };
        }

        default:
        return state;

    }

}